export default __webpack_public_path__ + "static/media/AVATARZ 4.484a21c7.png";